module.exports = __webpack_public_path__ + "static/media/chat-private-bubble-outlined.95cdc456.svg";